module.exports = __webpack_public_path__ + "static/img/game-NBA2K20.eba5527.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game/game-NBA2K20.jpg
// module id = 3iJn
// module chunks = 0